module.exports = "/fonts/english.svg?8926a32aa2523d089d575c650b2e0a93";


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/english.svg
// module id = dOzw
// module chunks = 3